import { useMemo } from 'react';

import { BootstrapVerticalColumnTable } from '@components/Table';
import { renderHeaderWithHover } from '@components/Table/Columns';
import { planDetailsApi } from '@reducers/plan';

const tableHeader = (title, accessor, fieldDescriptions) => {
  const Header = () =>
    renderHeaderWithHover(title, accessor, fieldDescriptions);
  return <Header />;
};

export const PlanServicesReachabilityTable = ({ data }) => {
  const query = planDetailsApi.useGetFieldDescriptionQuery();
  const fieldDescriptions = query.data || {};

  const columns = useMemo(
    () => [
      {
        Header: 'National Fixed',
        accessor: 'national_fixed',
      },
      {
        Header: 'National Mobile',
        accessor: 'national_mobile',
      },
      {
        Header: 'International',
        accessor: 'international',
      },
    ],
    []
  );

  return (
    <BootstrapVerticalColumnTable
      columns={columns}
      data={data}
      tableProps={() => ({
        responsive: true,
        bordered: true,
        style: { marginBottom: '0px' },
        className: 'normalFontSize',
      })}
      valueProps={() => ({ className: 'text-center' })}
      tableHeader={tableHeader(
        'Reachability',
        'reachability',
        fieldDescriptions
      )}
    />
  );
};

export const PlanServicesTable = ({ data }) => {
  const query = planDetailsApi.useGetFieldDescriptionQuery();
  const fieldDescriptions = query.data || {};
  const columns = useMemo(
    () => [
      {
        Header: 'Calling Card',
        accessor: 'calling_card',
      },
      {
        Header: 'VoIP Services',
        accessor: 'voip_services',
      },
      {
        Header: 'Call Back',
        accessor: 'call_back',
      },
    ],
    []
  );

  return (
    <BootstrapVerticalColumnTable
      columns={columns}
      data={data}
      tableProps={() => ({
        responsive: true,
        bordered: true,
        style: { marginBottom: '0px' },
        className: 'normalFontSize',
      })}
      valueProps={() => ({ className: 'text-center' })}
      tableHeader={tableHeader(
        'Allowed services',
        'allowed_services',
        fieldDescriptions
      )}
    />
  );
};
export const PlanDialFormatTable = ({ data }) => {
  const columns = useMemo(
    () => [
      {
        Header: 'Dial Format',
        accessor: 'dial_format',
        className: 'col-md-2',
      },
    ],
    []
  );
  return (
    <BootstrapVerticalColumnTable
      columns={columns}
      data={data}
      tableProps={() => ({
        responsive: true,
        bordered: true,
        style: { marginBottom: '0px' },
        className: 'normalFontSize',
      })}
      valueProps={() => ({ className: 'text-center' })}
      hideHeader
    />
  );
};

export const PlanServicesMinutesTable = ({ data }) => {
  const query = planDetailsApi.useGetFieldDescriptionQuery();
  const fieldDescriptions = query.data || {};
  const columns = useMemo(
    () => [
      {
        Header: 'Max call duration',
        accessor: 'max_call_duration',
        Cell: ({ value }) => value || 'N/A',
      },
      {
        Header: 'Max # min/day',
        accessor: 'max_min_day',
        Cell: ({ value }) => value || 'N/A',
      },
    ],
    []
  );

  return (
    <BootstrapVerticalColumnTable
      columns={columns}
      data={data}
      tableProps={() => ({
        responsive: true,
        bordered: true,
        style: { marginBottom: '0px' },
        className: 'normalFontSize',
      })}
      valueProps={() => ({ className: 'text-center' })}
      tableHeader={tableHeader('Minutes', 'minutes', fieldDescriptions)}
    />
  );
};

export const PlanOutboundOutreachTable = ({ data }) => {
  const columns = useMemo(
    () => [
      {
        Header: 'National Fixed Network',
        accessor: 'national_fixed',
        className: 'col-md-3',
      },
      {
        Header: 'National Mobile Network',
        accessor: 'national_mobile',
        className: 'col-md-1',
      },
      {
        Header: 'Toll Free',
        accessor: 'toll_free',
        className: 'col-md-1',
      },
    ],
    []
  );
  return (
    <BootstrapVerticalColumnTable
      columns={columns}
      data={data}
      tableProps={() => ({
        responsive: true,
        bordered: true,
        style: { marginBottom: '0px' },
        className: 'normalFontSize',
      })}
      valueProps={() => ({ className: 'text-center' })}
      tableHeader="Outreach"
    />
  );
};

export const PlanOutboundServicesTable = ({ data }) => {
  const columns = useMemo(() => [
    {
      Header: 'Call Center Allowed',
      accessor: 'call_center_allowed',
      className: 'col-md-1',
    },
  ]);
  return (
    <BootstrapVerticalColumnTable
      columns={columns}
      data={data}
      tableProps={() => ({
        responsive: true,
        bordered: true,
        style: { marginBottom: '0px' },
        className: 'normalFontSize',
      })}
      valueProps={() => ({ className: 'text-center' })}
      tableHeader="Services"
    />
  );
};
